import React from 'react';

const Projects = () => {
  const projects = [
    {
      title: 'ML Contract Violation Detector - VS Code Extension',
      description: 'Developed a VS Code extension that automatically detects and characterizes ML API contract violations using RAG and GenAI. The extension generates executable contract specifications for runtime validation and includes an interactive dashboard with automated testing pipeline and virtual environment management.',
      tech: ['VS Code API', 'JavaScript', 'Node.js', 'Python', 'RAG', 'GenAI'],
      github: 'https://github.com/Wasay-Dev100/MLSpecGen-VS-Extension',
      demo: null
    },
    {
      title: 'Bank Payment Application',
      description: 'Developed a secure full-stack banking application for account creation, fund transfers, and transaction history. Improved backend query performance by 30% through optimized database design. Deployed on AWS EC2 with Docker, enabling 100+ users in pilot testing to create accounts and transfer funds in real-time.',
      tech: ['Node.js', 'Express.js', 'React.js', 'PostgreSQL', 'AWS EC2', 'Docker'],
      github: '#',
      demo: '#'
    },
    {
      title: 'SRS to Project Generator',
      description: 'Developed an AI-powered VS Code extension that generates complete, production-ready MVC (Model-View-Controller) code from Software Requirements Specifications (SRS) documents. The extension supports multiple file formats (PDF, DOCX, TXT), features an interactive dashboard for requirement management, generates MVC applications for Python, JavaScript, Java, C#, and C++, and includes hybrid test generation with automated code verification.',
      tech: ['VS Code API', 'JavaScript', 'Node.js', 'Python', 'AI/ML', 'Natural Language Processing', 'Code Generation'],
      github: 'https://github.com/Wasay-Dev100/SRS-To-Project-Generator',
      demo: null
    }
  ];

  return (
    <section id="projects" className="projects">
      <div className="container">
        <h2 className="section-title">Projects</h2>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-image">
                <div className="project-placeholder">
                  <i className="fas fa-code"></i>
                </div>
              </div>
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-tech">
                  {project.tech.map((tech, idx) => (
                    <span key={idx} className="tech-tag">{tech}</span>
                  ))}
                </div>
                <div className="project-links">
                  {project.github && project.github !== '#' && (
                    <a href={project.github} className="project-link" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-github"></i> Code
                    </a>
                  )}
                  {project.demo && project.demo !== '#' && (
                    <a href={project.demo} className="project-link" target="_blank" rel="noopener noreferrer">
                      <i className="fas fa-external-link-alt"></i> Demo
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;

